<div class="panel">
  <div class="flex justify-between">
    <h6 class="mb-5 text-lg font-bold">
      {{ "customer_form.customer_info" | translate }}
    </h6>
    <div class="mb-6 flex" *appHasRole="[userRole.SuperAdmin]">
      <a (click)="setEditMode()" *ngIf="!isEditMode" class="btn btn-primary cursor-pointer rounded-full p-2 ltr:ml-auto rtl:mr-auto">
        <icon-pencil-paper />
      </a>
    </div>
  </div>
  <form [formGroup]="userSettingsForm">
    <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
      <div [class.has-error]="!userSettingsForm.get('companyName')?.valid && userSettingsForm.get('companyName')?.touched">
        <label class="form-label" for="companyName">{{ "customer_form.company_name" | translate }}</label>
        <input id="companyName" type="text" [placeholder]="'customer_form.enter_company_name' | translate" class="form-input" formControlName="companyName" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('name')?.valid && userSettingsForm.get('name')?.touched">
        <label class="form-label" for="name">{{ "customer_form.name" | translate }}</label>
        <input id="name" type="text" [placeholder]="'customer_form.enter_name' | translate" class="form-input" formControlName="name" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('surname')?.valid && userSettingsForm.get('surname')?.touched">
        <label class="form-label" for="surname">{{ "customer_form.surname" | translate }}</label>
        <input id="surname" type="text" [placeholder]="'customer_form.enter_surname' | translate" class="form-input" formControlName="surname" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('address')?.valid && userSettingsForm.get('address')?.touched">
        <label class="form-label" for="address">{{ "customer_form.address" | translate }}</label>
        <input id="address" type="text" [placeholder]="'customer_form.enter_address' | translate" class="form-input" formControlName="address" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('phone')?.valid && userSettingsForm.get('phone')?.touched">
        <label class="form-label" for="phone">{{ "customer_form.phone" | translate }}</label>
        <input id="phone" type="text" [placeholder]="'customer_form.enter_phone' | translate" class="form-input" formControlName="phone" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('email')?.valid && userSettingsForm.get('email')?.touched">
        <label class="form-label" for="email">{{ "customer_form.email" | translate }}</label>
        <input id="email" type="email" [placeholder]="'customer_form.enter_email' | translate" class="form-input" formControlName="email" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('pib')?.valid && userSettingsForm.get('pib')?.touched">
        <label class="form-label" for="pib">{{ "customer_form.pib" | translate }}</label>
        <input id="pib" type="text" [placeholder]="'customer_form.enter_pib' | translate" class="form-input" formControlName="pib" />
      </div>

      <div [class.has-error]="!userSettingsForm.get('mb')?.valid && userSettingsForm.get('mb')?.touched">
        <label class="form-label" for="mb">{{ "customer_form.mb" | translate }}</label>
        <input id="mb" type="text" [placeholder]="'customer_form.enter_mb' | translate" class="form-input" formControlName="mb" />
      </div>
    </div>

    <div class="mt-8 flex items-center justify-end" *ngIf="isEditMode">
      <button type="button" *ngIf="!isLoading" class="btn btn-danger w-52 cursor-pointer ltr:ml-4 rtl:mr-4" (click)="cancelEdit()">
        {{ "customer_form.cancel" | translate }}
      </button>
      <button type="button" *ngIf="!isLoading" class="btn btn-primary w-52 ltr:ml-4 rtl:mr-4" (click)="updateUser()">
        {{ "customer_form.save" | translate }}
      </button>
      <button *ngIf="isLoading" type="button" class="btn btn-primary ltr:ml-4 rtl:mr-4">
        <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>
        {{ "customer_form.loading" | translate }}
      </button>
    </div>
  </form>
</div>
